/* ==========================================================================
   Cart Drawer JS — AJAX cart, upsells, shipping bar, rotating reviews
   ========================================================================== */

(function() {
  'use strict';

  var drawer = document.querySelector('.cart-drawer');
  if (!drawer) return;

  var backdrop = drawer.querySelector('.cart-drawer__backdrop');
  var closeBtn = drawer.querySelector('.cart-drawer__close');
  var itemsContainer = drawer.querySelector('.cart-drawer__items');
  var footerEl = drawer.querySelector('.cart-drawer__footer');
  var shippingBar = drawer.querySelector('.cart-drawer__shipping-bar');
  var announcementBar = document.querySelector('.announcement-bar');

  var cartState = null;
  var FREE_SHIPPING_THRESHOLD = parseFloat(drawer.dataset.shippingThreshold || '31.90');
  var UPSELL_PRICE_3 = parseFloat(drawer.dataset.upsellPrice3 || '8.00');
  var UPSELL_PRICE_6 = parseFloat(drawer.dataset.upsellPrice6 || '8.00');
  var UPSELL_VARIANT_ID = drawer.dataset.upsellVariantId || '';
  var UPSELL_3PACK_VARIANT_ID = drawer.dataset.upsell3packVariantId || '';
  var UPSELL_3PACK_PRICE = parseFloat(drawer.dataset.upsell3packPrice || '39.25');

  /* ---------- Open / Close ---------- */
  function open() {
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    if (announcementBar) {
      announcementBar.style.opacity = '0';
      announcementBar.style.pointerEvents = 'none';
    }
    fetchCart();
  }

  function close() {
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
    if (announcementBar) {
      announcementBar.style.opacity = '';
      announcementBar.style.pointerEvents = '';
    }
  }

  document.addEventListener('cart:open', open);
  document.addEventListener('cart:close', close);
  if (backdrop) backdrop.addEventListener('click', close);
  if (closeBtn) closeBtn.addEventListener('click', close);

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });

  /* ---------- Cart API helpers ---------- */
  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        cartState = cart;
        render(cart);
        document.dispatchEvent(new CustomEvent('cart:update', { detail: cart }));
        return cart;
      });
  }

  function addToCart(variantId, quantity, sellingPlan) {
    var body = {
      items: [{
        id: parseInt(variantId),
        quantity: quantity || 1
      }]
    };
    if (sellingPlan) body.items[0].selling_plan = parseInt(sellingPlan);

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    })
    .then(function(r) { return r.json(); })
    .then(function() { return fetchCart(); });
  }

  function changeItem(lineKey, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: lineKey, quantity: quantity })
    })
    .then(function(r) { return r.json(); })
    .then(function() { return fetchCart(); });
  }

  /* ---------- Listen for add-to-cart events ---------- */
  document.addEventListener('cart:add', function(e) {
    var d = e.detail || {};
    // Support multiple items (main product + upsell)
    if (d.items && d.items.length > 0) {
      var cartItems = d.items.map(function(item) {
        var entry = { id: parseInt(item.id), quantity: item.quantity || 1 };
        if (item.selling_plan) entry.selling_plan = parseInt(item.selling_plan);
        return entry;
      });
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: cartItems })
      }).then(function() {
        window.location.href = '/checkout';
      });
    } else {
      addToCart(d.variantId, d.quantity, d.sellingPlan).then(function() {
        window.location.href = '/checkout';
      });
    }
  });

  /* ---------- Render ---------- */
  function render(cart) {
    if (!cart) return;
    renderShippingBar(cart);
    renderItems(cart);
    renderFooter(cart);
  }

  function renderShippingBar(cart) {
    if (!shippingBar) return;
    var total = cart.total_price / 100;
    var textEl = shippingBar.querySelector('.cart-drawer__shipping-text');
    var fillEl = shippingBar.querySelector('.cart-drawer__shipping-fill');

    if (total >= FREE_SHIPPING_THRESHOLD) {
      textEl.innerHTML = '<span style="color:var(--color-success)">You\'ve unlocked FREE shipping!</span>';
      fillEl.style.width = '100%';
    } else {
      var away = (FREE_SHIPPING_THRESHOLD - total).toFixed(2);
      textEl.innerHTML = 'You\'re <strong style="color:var(--color-primary)">$' + away + '</strong> away from FREE shipping!';
      fillEl.style.width = Math.min((total / FREE_SHIPPING_THRESHOLD) * 100, 100) + '%';
    }
  }

  function renderItems(cart) {
    if (!itemsContainer) return;

    if (cart.item_count === 0) {
      itemsContainer.innerHTML =
        '<div class="cart-drawer__empty">' +
          '<p class="cart-drawer__empty-text">' + (drawer.dataset.emptyMessage || 'Your cart is empty') + '</p>' +
          '<a href="/products/packs" class="btn btn--primary">Shop Now</a>' +
        '</div>';
      if (footerEl) footerEl.style.display = 'none';
      return;
    }

    if (footerEl) footerEl.style.display = '';

    var html = '';
    cart.items.forEach(function(item) {
      html += renderCartItem(item);
    });

    // Upsell logic
    var upsellHtml = renderUpsell(cart);
    if (upsellHtml) html += upsellHtml;

    itemsContainer.innerHTML = html;
    bindItemEvents();
  }

  function renderCartItem(item) {
    var img = item.image ? item.image.replace(/(\.[^.]+)$/, '_200x200$1') : '';
    var sellingPlanHtml = '';
    if (item.selling_plan_allocation) {
      sellingPlanHtml = '<div class="cart-item__selling-plan">Subscribe & Save — Every 30 days</div>';
    }

    return (
      '<div class="cart-item" data-key="' + item.key + '">' +
        '<img class="cart-item__image" src="' + img + '" alt="' + item.product_title + '" loading="lazy">' +
        '<div class="cart-item__details">' +
          '<div class="cart-item__title">' + item.product_title + '</div>' +
          '<div class="cart-item__variant">' + item.variant_title + '</div>' +
          sellingPlanHtml +
          '<div class="cart-item__price">$' + (item.final_line_price / 100).toFixed(2) + '</div>' +
          '<div class="cart-item__actions">' +
            '<button class="cart-item__qty-btn" data-action="decrease" data-key="' + item.key + '" aria-label="Decrease quantity">' +
              '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="5" y1="12" x2="19" y2="12"/></svg>' +
            '</button>' +
            '<span class="cart-item__qty">' + item.quantity + '</span>' +
            '<button class="cart-item__qty-btn" data-action="increase" data-key="' + item.key + '" aria-label="Increase quantity">' +
              '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>' +
            '</button>' +
            '<button class="cart-item__remove" data-action="remove" data-key="' + item.key + '">Remove</button>' +
          '</div>' +
        '</div>' +
      '</div>'
    );
  }

  function renderUpsell(cart) {
    var has3pack = false;
    var has6pack = false;
    var has1pack = false;
    var has2pack = false;

    cart.items.forEach(function(item) {
      var title = (item.variant_title || '').toLowerCase();
      if (title.indexOf('10 pack') !== -1 || title.indexOf('6 pack') !== -1 || title.indexOf('6-pack') !== -1) has6pack = true;
      if (title.indexOf('3 pack') !== -1 || title.indexOf('3-pack') !== -1) has3pack = true;
      if (title.indexOf('2 pack') !== -1 || title.indexOf('2-pack') !== -1) has2pack = true;
      if (title.indexOf('1 pack') !== -1 || title.indexOf('1-pack') !== -1) has1pack = true;
    });

    if (!UPSELL_VARIANT_ID || has1pack) return '';
    if (!has2pack && !has3pack && !has6pack) return '';

    var price;
    if (has6pack) price = UPSELL_PRICE_6;
    else if (has3pack) price = UPSELL_PRICE_3;
    else price = 5.35;

    var comparePrice = 16.95;
    var savings = Math.round((1 - price / comparePrice) * 100);

    return (
      '<div class="cart-upsell">' +
        '<div class="cart-upsell__heading">Grab one for a friend?</div>' +
        '<div class="cart-upsell__row">' +
          '<span>1 Pack — <strong class="cart-upsell__price">$' + price.toFixed(2) + '</strong> ' +
            '<span class="cart-upsell__compare">$' + comparePrice.toFixed(2) + '</span> ' +
            '<span class="cart-upsell__savings">Save ' + savings + '%</span>' +
          '</span>' +
          '<button class="cart-upsell__add" data-upsell-add>Add</button>' +
        '</div>' +
      '</div>'
    );
  }

  function renderFooter(cart) {
    if (!footerEl || cart.item_count === 0) return;

    var subtotalEl = footerEl.querySelector('.cart-drawer__subtotal-price');
    if (subtotalEl) {
      subtotalEl.textContent = '$' + (cart.total_price / 100).toFixed(2);
    }

    // Savings calculation
    var savingsEl = footerEl.querySelector('.cart-drawer__savings');
    if (savingsEl) {
      var savings = 0;
      cart.items.forEach(function(item) {
        if (item.original_line_price > item.final_line_price) {
          savings += (item.original_line_price - item.final_line_price);
        }
      });
      if (savings > 0) {
        savingsEl.textContent = "You're saving $" + (savings / 100).toFixed(2);
        savingsEl.style.display = '';
      } else {
        savingsEl.style.display = 'none';
      }
    }
  }

  function bindItemEvents() {
    itemsContainer.querySelectorAll('[data-action]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var key = btn.dataset.key;
        var action = btn.dataset.action;
        if (action === 'increase') {
          var item = findItem(key);
          if (item) changeItem(key, item.quantity + 1);
        } else if (action === 'decrease') {
          var item2 = findItem(key);
          if (item2 && item2.quantity > 1) changeItem(key, item2.quantity - 1);
          else changeItem(key, 0);
        } else if (action === 'remove') {
          changeItem(key, 0);
        }
      });
    });

    var upsellBtn = itemsContainer.querySelector('[data-upsell-add]');
    if (upsellBtn) {
      upsellBtn.addEventListener('click', function() {
        addToCart(UPSELL_VARIANT_ID, 1);
      });
    }

  }

  function findItem(key) {
    if (!cartState) return null;
    for (var i = 0; i < cartState.items.length; i++) {
      if (cartState.items[i].key === key) return cartState.items[i];
    }
    return null;
  }

  /* ---------- Rotating reviews ---------- */
  var reviewEls = footerEl ? footerEl.querySelectorAll('.cart-drawer__review') : [];
  if (reviewEls.length > 1) {
    var currentReview = 0;
    reviewEls.forEach(function(el, i) {
      el.style.display = i === 0 ? '' : 'none';
    });
    setInterval(function() {
      reviewEls[currentReview].style.display = 'none';
      currentReview = (currentReview + 1) % reviewEls.length;
      reviewEls[currentReview].style.display = '';
    }, 5000);
  }

})();
